import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Barcode({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Barcode</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 7C5.16421 7 5.5 7.33579 5.5 7.75L5.5 16.25C5.5 16.6642 5.16421 17 4.75 17C4.33579 17 4 16.6642 4 16.25L4 7.75C4 7.33579 4.33579 7 4.75 7Z"
        fill={color ?? 'currentColor'}
      />
      <rect x="7.5" y="7" width="4" height="10" rx="1" fill={color ?? 'currentColor'} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.25 7C14.6642 7 15 7.33579 15 7.75L15 16.25C15 16.6642 14.6642 17 14.25 17C13.8358 17 13.5 16.6642 13.5 16.25L13.5 7.75C13.5 7.33579 13.8358 7 14.25 7Z"
        fill={color ?? 'currentColor'}
      />
      <rect x="17" y="7" width="3" height="10" rx="1" fill={color ?? 'currentColor'} />
    </svg>
  );
}
